import { render, staticRenderFns } from "./colorChart.vue?vue&type=template&id=051df40f&scoped=true&"
import script from "./colorChart.vue?vue&type=script&lang=js&"
export * from "./colorChart.vue?vue&type=script&lang=js&"
import style0 from "./colorChart.vue?vue&type=style&index=0&id=051df40f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051df40f",
  null
  
)

export default component.exports